import React, { Fragment } from "react";
import CommonCard from "../../common/components/CommonCard";
import { Box, Divider, Grid, Typography } from "@mui/material";
import theme from "../../theme";
import CommonSelect from "../../common/components/CommonSelect";
import { Days, Duration, Frequency, Time } from "../../common/const";

const Schedule = ({
    formData,
    handleInputChange,
    errors
}) => {
    return (
        <CommonCard
            paddingBottom="0px"
            border={`1px solid #0000001A`}
            borderRadius={2}
            background="#EBCDF9"
            padding="0px"
            headerContent={
                <Fragment>
                    <Box p={2}>
                        <Typography fontWeight={600} fontSize={18}>Scheduling & Availability</Typography>
                        <Typography fontSize={14} color={theme.palette.background.dark}>Add your Scheduling & Availability</Typography>
                    </Box>
                    <Divider />
                </Fragment>
            }
            content={
                <Grid container spacing={2} p={2}>
                    <Grid item md={6}>
                        <CommonSelect
                            label="Preferred Days"
                            name="days"
                            value={formData.days}
                            onChange={handleInputChange}
                            placeholder="Select Days"
                            options={Days}
                            error={errors.days}
                        />
                    </Grid>
                    <Grid item md={6}>
                        <CommonSelect
                            label="Preferred Time"
                            name="time"
                            value={formData.time}
                            onChange={handleInputChange}
                            placeholder="Select Time"
                            options={Time}
                            error={errors.time}
                        />
                    </Grid>
                    <Grid item md={6}>
                        <CommonSelect
                            label="Frequency"
                            name="frequency"
                            value={formData.frequency}
                            onChange={handleInputChange}
                            placeholder="Select Frequency"
                            options={Frequency}
                            error={errors.frequency}
                        />
                    </Grid>
                    <Grid item md={6}>
                        <CommonSelect
                            label="Session Duration"
                            name="duration"
                            value={formData.duration}
                            onChange={handleInputChange}
                            placeholder="Select Duration"
                            options={Duration}
                            error={errors.duration}
                        />
                    </Grid>
                </Grid>
            }
        />
    )
}

export default Schedule;